import { render, staticRenderFns } from "./AssetDashboard.vue?vue&type=template&id=6f45947a&scoped=true&"
import script from "./AssetDashboard.vue?vue&type=script&lang=js&"
export * from "./AssetDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AssetDashboard.vue?vue&type=style&index=0&id=6f45947a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f45947a",
  null
  
)

export default component.exports